import React from "react";

import AcompanhamentoCargaTopo from "./topo";
import AcompanhamentoCargaDetalhes from "./detalhe";
import br from "date-fns/locale/pt-BR";

import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

import styles from './detail.module.css';

export default function AcompanhamentoCargaPage() {
  return (
    <React.Fragment>
      <div
        className={`container ${styles.container}`}
      >
        <div className={`gridScroll ${styles.table}`} style={{ backgroundColor: "#FFFAFA" }}>
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterlocale={br}>
            <AcompanhamentoCargaTopo />
            <AcompanhamentoCargaDetalhes />
          </LocalizationProvider>
        </div>
      </div>
    </React.Fragment>
  );
}
